module.exports = __webpack_public_path__ + "static/media/imove.22460652.svg";